

import React, { useEffect, useRef, useState } from 'react';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

export default function DialogConfirm( { show , answer}) {
    const [visible, setVisible] = useState(false);
    const toast = useRef(null);
    const buttonEl = useRef(null);

    useEffect(() => {
        setVisible( show )
    } , [show])

    const accept = () => {
        answer(true) ; toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'Ha aceptado', life: 3000 });
    };

    const reject = () => {
        answer( false ) ; toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'Ha rechazado', life: 3000 });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmPopup target={buttonEl.current} visible={visible} onHide={() => setVisible(false)} 
                message="Desea subir la tabla a produccion?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />
            {/* <div className="card flex justify-content-center">
                <Button ref={buttonEl} onClick={() => setVisible(true)} icon="pi pi-check" label="Confirm" /> 
            </div> */}
        </>
    )
}
        